export const accessRightsConfig = {
    // name of the claim that contains roles in the JWT token
    rolesClaimName: process.env.ROLES_JWT_CLAIM ?? "roles",
};
